<template>
  <Fragment>
    <SectionHeader>
      <template v-slot:breadcrumbs>
        <BreadCrumbs :items="[{ text: userName }]" />
      </template>
      <template slot="meta">
        <Link :to="`/company`" class="button button-grey button-round button-small">{{
          $t('meta.backToOverview')
        }}</Link>
      </template>
    </SectionHeader>
    <div class="body-content cf">
      <CompanyNav />
      <div class="body">
        <LoadingSpinner v-if="loading" />
        <UserBaseData
          v-else-if="companyUserToEdit"
          :templateMode="'edit'"
          :user="companyUserToEdit"
          :onSubmitBaseData="updateUserData"
        />
      </div>
    </div>
  </Fragment>
</template>
<script>
import { Fragment } from 'vue-fragment'

import BreadCrumbs from '@/components/BreadCrumbs'
import LoadingSpinner from '@/components/LoadingSpinner'
import SectionHeader from '@/components/SectionHeader'
import UserBaseData from '@/components/UserBaseData'
import CompanyNav from '@/components/company_nav.vue'

import companyUsersApi from '@/api/companyUsers'

export default {
  name: 'CompanyUserEdit',
  inject: ['companyUser'],
  components: {
    BreadCrumbs,
    CompanyNav,
    Fragment,
    LoadingSpinner,
    UserBaseData,
    SectionHeader,
  },
  data: () => ({
    companyUserToEdit: null,
    loading: true,
  }),
  computed: {
    userName() {
      if (!this.companyUserToEdit) return
      return this.companyUserToEdit.user.first_name + ' ' + this.companyUserToEdit.user.last_name
    },
  },
  methods: {
    async deleteCompanyUser() {
      await companyUsersApi.delete(this.companyUserToEdit.uuid)
      await this.$router.push('/company')
    },
    async updateUserData(data) {
      const { first_name, last_name, roles } = data
      const params = {
        user: {
          first_name,
          last_name,
        },
        roles,
      }
      await companyUsersApi.update(this.companyUserToEdit.uuid, params)
      await this.$router.push('/company')
    },
  },
  async created() {
    this.companyUserToEdit = await companyUsersApi.get(this.$route.params.user_uuid)
    this.loading = false
  },
}
</script>
